import PropTypes from 'prop-types';
import { flexRender } from '@tanstack/react-table';
import { Skeleton } from '@repo/zolintra-ui';
import styles from './Tables.module.css';

export function PostCards({
  table, rows, onOpen, getActions, isLoading,
}) {
  if (isLoading) {
    return (
      <div className={styles.cards}>
        {['a', 'b', 'c', 'd'].map((key) => (
          <Skeleton key={key} shape="rectangle" width="100%" height="8rem" />
        ))}
      </div>
    );
  }

  const headers = table.getHeaderGroups()[0]?.headers ?? [];

  return (
    <ul className={styles.cards}>
      {rows.map((row) => {
        const actions = getActions(row).filter((action) => !action.hidden);

        return (
          <li key={row.id} className={styles.card}>
            {onOpen ? (
              <button type="button" className={styles['card-body']} onClick={() => onOpen(row)}>
                <CardFields row={row} headers={headers} />
              </button>
            ) : (
              <div className={styles['card-body']}>
                <CardFields row={row} headers={headers} />
              </div>
            )}
            {actions.length ? (
              <div className={styles['card-actions']}>
                {actions.map((action) => (
                  <button
                    key={action.label}
                    type="button"
                    className={styles['card-action']}
                    style={action.style}
                    onClick={(event) => {
                      event.stopPropagation();
                      action.onClick();
                    }}
                  >
                    {action.label}
                  </button>
                ))}
              </div>
            ) : null}
          </li>
        );
      })}
    </ul>
  );
}

function CardFields({ row, headers }) {
  return row.getVisibleCells().map((cell) => {
    const header = headers.find((item) => item.column.id === cell.column.id);

    return (
      <div key={cell.id} className={styles['card-field']}>
        <span className={styles['card-label']}>
          {header ? flexRender(header.column.columnDef.header, header.getContext()) : null}
        </span>
        <div className={styles['card-value']}>
          {flexRender(cell.column.columnDef.cell, cell.getContext())}
        </div>
      </div>
    );
  });
}

CardFields.propTypes = {
  row: PropTypes.shape({
    getVisibleCells: PropTypes.func.isRequired,
  }).isRequired,
  headers: PropTypes.arrayOf(PropTypes.shape({
    column: PropTypes.shape({
      id: PropTypes.string,
      columnDef: PropTypes.shape({
        header: PropTypes.oneOfType([PropTypes.node, PropTypes.func]),
      }),
    }),
    getContext: PropTypes.func,
  })).isRequired,
};

PostCards.propTypes = {
  table: PropTypes.shape({
    getHeaderGroups: PropTypes.func,
  }),
  rows: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.string,
  })),
  onOpen: PropTypes.func,
  getActions: PropTypes.func,
  isLoading: PropTypes.bool,
};

PostCards.defaultProps = {
  table: null,
  rows: [],
  onOpen: undefined,
  getActions: () => [],
  isLoading: false,
};

export default PostCards;
